import styled from 'styled-components';

const getFontSize = (props) => {
  if (props.smallFontSize) return '18px';
  if (props.isMobileResolution) return '20px';
  return '32px';
};

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledHeaderTitle = styled.div`
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  font-size: ${(props) => getFontSize(props)};
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  align-self: center;
  margin-left: ${(props) => (props.showIcon ? '12px' : '0')};
  word-wrap: break-word;
  max-width: ${(props) => (props.isMobileResolution ? 'calc(100vw - 80px)' : 'auto')};
`;
